import { Alert } from '../../components/ui';
import MedicoNav from './MedicoNav';
import './Medico.css';

export default function MedicoHeader({ titulo }) {
  return (
    <>
      <h1 style={{ marginBottom: 4 }}>{titulo}</h1>
      <p className="medico-muted" style={{ margin: 0 }}>Dra. Laura González · Cardiología</p>
      <MedicoNav />
      <Alert tone="info">Vista de maqueta con datos de ejemplo (la integración de esta pantalla no es requisito de la Entrega 3).</Alert>
    </>
  );
}